<template>
  <div>
    <div class="state-box" style="flex-shrink: 0 " :class="[state ==='enabled'? 'enabledColor':'',state ==='paused'? 'pausedColor':'',state==='archived'? 'archivedColor':'']"></div>
  </div>
</template>

<script>
export default {
  props: {
    state: String
  }

}
</script>

<style lang="scss" scoped>
.state-box{
  width: 6px;
  height: 6px;
  border-radius: 50%;
}
.enabledColor{
  background-color: $main-color;
}
.pausedColor{
  background-color: $G7
}
.archivedColor{
  background-color: $G6;
}
</style>
